module.exports = __webpack_public_path__ + "img/media-team.c670ccb1.svg";